import { Menu } from '@mui/icons-material'
import { Avatar, Box, IconButton, Paper, Popover } from '@mui/material'
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { NivosAccountMenu } from 'components/index'
import { DRAWER_WIDTH } from 'constants/layout'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const NivosHeaderFC: React.FC<any> = (props: AppProps) => {
  const { layout, operations, user } = props
  const [open, setOpen] = React.useState(false)
  const accountSettingsBtn = useRef(null)

  return (
    <Box minHeight={20} position={'fixed'} zIndex={2} width={1}>
      <Paper style={{ width: '100%', margin: 0 }} elevation={3}>
        <Box
          display={'flex'}
          paddingX={1}
          paddingRight={layout.drawerIsOpen ? `${DRAWER_WIDTH}px` : 0}
          style={{ transition: '.5s' }}
        >
          <Box
            alignItems={'center'}
            justifyContent={'space-between'}
            display={'flex'}
            flexGrow={1}
          >
            <IconButton
              onClick={() =>
                operations.layout.update({
                  drawerIsOpen: !layout.drawerIsOpen
                })
              }
            >
              <Menu color={'primary'} />
            </IconButton>
          </Box>
          <Box display={'flex'} alignItems={'center'}>
            <IconButton
              ref={accountSettingsBtn}
              onClick={() => setOpen(true)}
              sx={{ marginRight: 2 }}
            >
              <Avatar src={user.image?.url} />
            </IconButton>
            <Popover
              open={open}
              onClose={() => setOpen(false)}
              anchorEl={accountSettingsBtn.current}
              elevation={8}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              PaperProps={{
                sx: {
                  borderRadius: '12px'
                }
              }}
            >
              <NivosAccountMenu />
            </Popover>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosHeader = connect(mapStateToProps, mapDispatchToProps)(NivosHeaderFC)

export default NivosHeader
